<template>
	<header class="masthead mb-auto">
		<nav
			class="navbar navbar-expand-lg navbar-dark bg-transparent"
			v-bind:class="{ 'bg-no-trans': currentNavSearch }"
		>
			<div class="container-fluid">
				<a class="navbar-brand" href="/#/home">
					<img src="../assets/img/logo.png" alt="Logo" />
				</a>
				<button
					class="navbar-toggler"
					type="button"
					data-toggle="collapse"
					data-target="#navbarsExample01"
					aria-controls="navbarsExample01"
					aria-expanded="false"
					aria-label="Toggle navigation"
				>
					<span class="navbar-toggler-icon"></span>
				</button>
				<div class="collapse navbar-collapse" id="navbarsExample01">
					<ul class="navbar-nav mr-auto pl-sm-0 pl-md-0 pl-lg-5">
						<li
							class="nav-item active"
							v-for="(menu, index) in menuItems"
							:key="index"
						>
							<a class="nav-link" :href="menu.path">{{ menu.name }}</a>
						</li>
					</ul>
					<ul class="navbar-nav ml-auto align-items-center navWithSearch">
						<li
							class="nav-item active d-flex"
							v-if="$store.state.globalconfigs.enable_search == 'TRUE'"
						>
							<a
								class="nav-link searchicn"
								@click="showSearchPage"
								data-toggle="collapse"
								href="#collapsesearch"
								><i class="fa fa-search" aria-hidden="true"></i
							></a>
							<div class="collapse searchpopup" id="collapsesearch">
								<input class="form-control" type="text" v-model="message" />
							</div>
						</li>

						
						<li class="nav-item dropdown">
							<a
								class="nav-link"
								href="#"
								id="dropdown02"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
								<span class="notification-number" v-if="badgeCount">{{
									badgeCount
								}}</span>
								<i class="fa fa-bell" aria-hidden="true"></i>
							</a>
							<div
								class="dropdown-menu  menu1 movie-menu dropdown-menu-right"
								aria-labelledby="dropdown02"
							>
								<span class="dropdown-menu-arrow"></span>
								<ComingSoon
									v-for="(item, index) in upComingVideos"
									:item="item"
									:key="index"
								/>
							</div>
						</li>
						
						<li class="nav-item">
							<a class="nav-link" href="#" tabindex="-1" aria-disabled="true">
								<img
									v-bind:src="require(`@/assets/img/${this.n}.png`)"
									alt
									height="40px"
									width="40px"
									style="vertical-align: top"
								/>
							</a>
						</li>
						<li class="nav-item dropdown">
							<a
								class="nav-link dropdown-toggle"
								href="#"
								id="dropdown01"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
								>{{ username }}</a
							>
							<div
								class="dropdown-menu dropdown-menu-right front"
								aria-labelledby="dropdown01"
							>
								<span class="dropdown-menu-arrow"></span>
								<a class="dropdown-item front" href="/#/profile2">
									Manage Profile</a
								>
								<a class="dropdown-item front" href="/#/account">Account</a>
								<a class="dropdown-item front" @click="onSwitched">
									Switch to <span v-if="displayMode=='light'">Dark</span> <span v-if="displayMode=='dark'">Light</span> Mode</a
								>
								<a class="dropdown-item front" href="/#/mediaCenter"
									>Help Center</a
								>
								<a class="dropdown-item pointer front" @click="logout"
									>Sign Out</a
								>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	</header>
</template>

<script>
import ComingSoon from "./ComingSoon.vue";
 
export default {
	components: { ComingSoon},
	name: "HomeNav",
	methods: {
		showSearchPage() {
			this.$store.commit("updateSearchMessage", "");
			if (this.$route.name == "search") {
				this.$router.go(-1);
			} else {
				this.$router.push("/search");
			}
		},
		goToaccount() {
			this.$router.push("/account");
		},
		logout() {
			this.$store.dispatch("logout").then((res) => {
				if (res == "true") {
					this.$router.push("/");
				}
			});
		},
		calculateBadge() {
			this.readNotification = localStorage.getItem("readNotification");
			this.readNotification = JSON.parse(this.readNotification);
			if (this.readNotification) {
				this.upComingVideos.forEach((element) => {
					if (this.readNotification.indexOf(element.id) == -1) {
						this.badgeCount++;
					}
				});
			} else {
				this.badgeCount = this.upComingVideos.length;
			}
		},
		onSwitched() {
			if(this.displayMode=='light'){
				this.$store.commit("setDisplayMode",true)
			}
			else{
				this.$store.commit("setDisplayMode",false)
			}
			}
	},
	created() {
		this.showBanner = false;
		this.$store.commit("showPopup", false);
		this.menuItems = JSON.parse(this.$store.state.globalconfigs.menu_config);
		this.menuItems.splice(1,1)
		this.profileData = this.$store.getters.getUserInfo.profile.metaData;
			if (this.profileData.image_id) {
				this.n = this.profileData.image_id;
			} else {
				this.n = 0;
			}
		this.username = this.$store.getters.getUserInfo.profile.first_name;
		 
		this.$store
			.dispatch("getCatalougeById", "5ee30a13627d26001c8c3e33")
			.then((res) => {
				if(res._embedded.items && res._embedded.items.length>0){
				this.bannerData = res._embedded.items[0];
				this.banner1 = this.bannerData.languages[0].thumbnail.large;
				this.showBanner = true;
				}
				
			});
		if ( !this.$store.getters.getUserInfo.profile || this.$store.getters.getUserInfo.profile.first_name == "undefined") {
				if (this.$store.getters.getUserInfo) {
					this.n = this.profileData.image_id;
					if (this.$store.getters.getUserInfo.profile) {
						this.username = this.$store.getters.getUserInfo.profile.first_name;
					}
				} else {
					this.username = "User";
				}
		} else {
			this.username = this.$store.getters.getUserInfo.profile.first_name;
		}
		this.notificationCatalogueId = this.$store.getters.getGlobalConfigs.notification_catalogue;
		this.$store
			.dispatch("getCatalougeById", this.notificationCatalogueId)
			.then((res) => {
				this.upComingVideos = res._embedded.items;
				this.calculateBadge();
			});
	},
	data() {
		return {
			username: null,
			bannerData: null,
			showBanner: false,
			menuItems: [],
			banner1: "/img/homepage-bg.a82c63d7.png",
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
			n: 0,
			upComingVideos: null,
			readNotification: [],
			badgeCount: null,
			notificationCatalogueId: null,
			isDarkModeEnabled: false
		};
	},
	computed: {
		currentNavSearch() {
			if (
				this.$route.name == "search" ||
				this.$route.name == "contact" ||
				this.$route.name == "mediaCenter" ||
				this.$route.name == "faqs" ||
				this.$route.name == "Terms" ||
				this.$route.name == "CookiesPrivacy" ||
				this.$route.name == "Account" ||
				this.$route.name == "Profile" ||
				this.$route.name == "Profile1" ||
				this.$route.name == "Profile2" ||
				this.$route.name == "listMovies" ||
				this.$route.name == "ListMyList" ||
				this.$route.name == "ListRecent" ||
				this.$route.name == "ListSeries"
			) {
				return true;
			} else {
				return false;
			}
		},

		message: {
			get() {
				return this.$store.state.search.message;
			},
			set(value) {
				this.$store.commit("updateSearchMessage", value);
			},
		},
		displayMode() {
			return this.$store.getters.getDisplayMode;
		},
	},
};
</script>

<style scoped>
.bg-no-trans {
	background-color: var(--navbar-bg-color) !important;
}
.tooltip {
	position: relative;
	display: inline-block;
	border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
	visibility: hidden;
	width: 120px;
	background-color: black;
	color: #fff;
	text-align: center;
	border-radius: 6px;
	padding: 5px 0;

	/* Position the tooltip */
	position: absolute;
	z-index: 1;
}

.tooltip:hover .tooltiptext {
	visibility: visible;
}
.notification-number {
	position: absolute;
	top: 1px;
	left: 4px;
	width: 18px;
	height: 18px;
	border-radius: 100%;
	text-align: center;
	letter-spacing: 0px;
	font-size: 0.8rem;
	color: #f1f2f2;
	opacity: 1;
	background: #43602d 0% 0% no-repeat padding-box;
	box-shadow: 0px 0px 3px #00000029;
	opacity: 1;
}
.pointer {
	cursor: pointer;
}
.menu1 {
	height: 15rem;
	overflow-y: scroll;
	overflow-x: hidden;
}
.navbar {
	z-index: 2 !important;
}
</style>
